// import logo from './assets/images/logo_B.svg';
import React, { useEffect } from 'react';
import {Route, Routes, useLocation, Navigate, useParams, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import './App.scss';

import Header from './sections/Header/index.js';
import Footer from './sections/Footer/index.js';
import SmallFooter from "./sections/SmallFooter/index.js";

import Home from './pages/Home/index.js';
import Banquets from './pages/Banquets/index.js';
import Catering from "./pages/Catering/index.js";
import Menu from "./pages/Menu/index.js";
import About from "./pages/About/index.js";
import Contacts from "./pages/Contacts/index.js";
import ScrollToTop from "./helpers/ScrollToTop.js"; // Подключаем наш компонент
// import Reservation from "./pages/Reservation/index.js";
import StatusSuccess from "./pages/StatusSuccess/index.js";
import ReservationCaptchWrapp from "./pages/ReservationCaptchWrapp/index.js";
// import { useTranslation } from 'react-i18next';

function App() {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (lang && i18n.language !== lang) {
      i18n.changeLanguage(lang); 
    }
  }, [lang, i18n]);

  useEffect(() => {
    if (!lang) {
      navigate(`/${i18n.language}/`); 
    }
  }, [lang, i18n.language, navigate]);

  const location = useLocation(); 

  const currentLang = location.pathname.split('/')[1]; 
  const supportedLanguages = ['en', 'ua', 'nl']; 

  if (!supportedLanguages.includes(currentLang) || !currentLang) {
    return <Navigate to={`/en${location.pathname.split('/').slice(2).join('/')}`} replace />;
  }

  if (i18n.language !== currentLang) {
    i18n.changeLanguage(currentLang);
  }

  return (
    <div className="App">
      <ScrollToTop/>
      <Header/>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/menu" element={<Menu/>}/>
        <Route path="/banquets" element={<Banquets/>}/>
        <Route path="/catering" element={<Catering/>}/>
        <Route path="/about" element={<About/>}/>
        <Route path="/contacts" element={<Contacts/>}/>
        <Route path="/reservation" element={<ReservationCaptchWrapp/>}/>
        <Route path="/statusSuccess" element={<StatusSuccess/>}/>
      </Routes>
      {/* Условно отображаем футер */}
      {location.pathname.includes('/reservation') ? <SmallFooter /> : <Footer />}
    </div>
  );
}

export default App;
